/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Subject } from 'rxjs';
import { KnowledgeBaseFilterInfo } from '../model/knowledgebasefilterinfo';


export class KnowledgeBaseFilterService {
    private subjectForFilterInfo = new Subject<KnowledgeBaseFilterInfo>();
    private subjectForSearchTerm = new Subject<KnowledgeBaseFilterInfo>();

    applyFilter(filter: KnowledgeBaseFilterInfo) {
        this.subjectForFilterInfo.next(filter);
    }

    getFilter(): Subject<KnowledgeBaseFilterInfo> {
        return this.subjectForFilterInfo;
    }

    applySearchFilter(filter: KnowledgeBaseFilterInfo) {
        this.subjectForSearchTerm.next(filter);
    }

    getSearchFilter(): Subject<KnowledgeBaseFilterInfo> {
        return this.subjectForSearchTerm;
    }
}
